import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { RefreshCw } from 'lucide-react'

export function LoadingState(): ReactElement {
  const { t } = useTranslation('cases')
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <RefreshCw className="h-6 w-6 animate-spin text-[#4e5e82]" />
        <p className="text-sm text-slate-500 dark:text-slate-400">
          {t('infrastructure.loadingEndpoints')}
        </p>
      </div>
    </div>
  )
}

export function ErrorState({
  error,
  onRetry,
}: {
  error: string
  onRetry: () => void
}): ReactElement {
  const { t } = useTranslation('cases')
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="text-center">
        <p className="text-red-600 dark:text-red-400">{error}</p>
        <button
          onClick={onRetry}
          className="mt-4 text-sm text-lime-600 hover:underline dark:text-lime-400"
        >
          {t('infrastructure.tryAgain')}
        </button>
      </div>
    </div>
  )
}

export function ImportDropdownBackdrop({ onClose }: { onClose: () => void }): ReactElement {
  return <div className="fixed inset-0 z-0" onClick={onClose} />
}
